import { Container, Nav, Navbar, NavbarCollapse, NavbarToggle, NavLink } from "react-bootstrap"
import SearchComponent from "../SearchComponent"
import ContactPersonDrop from "../../hw/contactPersonSwitch/ContactPersonDrop"
import EnergoProfileDrop from "../profile_drop/EnergoProfileDrop";
import { FaInfoCircle } from "react-icons/fa";
import { useTooltips } from "../../../context/TooltipsContext";

/**
 * ENERGO Navbar
 * 
 * @param {array} menuOptions array of objects with key (id, icon, text, link)
 * @param {boolean} hasSearch booelan if search should be shown
 * @param {boolean} isHw boolean for extended menu for hw
 * @returns 
 */
const EnergoNavbar = ({ menuOptions, hasSearch, isHw }) => {

    const { tooltipsTrigger, toggleTrigger } = useTooltips(); // tooltips 

    const toggleTooltips = () => {
        toggleTrigger(!tooltipsTrigger);
    }

    return (
        <header className="App-header">
            <Navbar expand="false" variant="dark" className="bg-energo">
                <Container fluid>
                    <NavbarToggle
                        className="sb-navbar-toggle"
                        aria-controls="energo-navbar-nav"
                        style={{ border: "1px solid white" }}
                    />
                    {hasSearch ? <SearchComponent /> : <div></div>}
                    {isHw ?
                        <div style={{ display: "flex", gap: 5 }}>
                            <ContactPersonDrop />
                            <EnergoProfileDrop />
                        </div> :
                        <EnergoProfileDrop />
                    }
                    <NavbarCollapse id="energo-navbar-nav">
                        <Nav>
                                <div className="mt-3 d-flex" style={{ justifyContent: "space-between", alignItems: "center" }}>
                                    {isHw &&
                                        <ContactPersonDrop isModal />
                                    }
                                    <a 
                                        href="tooltips/"
                                        onClick={e => {e.preventDefault(); toggleTooltips()}}
                                        className={tooltipsTrigger !== undefined && tooltipsTrigger === true ?
                                            "text-warning glow-effect" : 'text-light'
                                        }
                                    >
                                        <FaInfoCircle size={27} />
                                    </a>
                                    <hr />
                                </div>
                            {menuOptions && menuOptions.length > 0 &&
                                menuOptions.map(opt => (
                                    <NavLink key={`nav-${opt.id}`} className="text-light" href={opt.link}>{opt.text}</NavLink>
                                ))
                            }
                        </Nav>
                    </NavbarCollapse>
                </Container>
            </Navbar>
        </header>
    )
}
export default EnergoNavbar;